import navigateToNextLooksmaxxingOnboardingPageAction from "@actions/navigateToNextLooksmaxxingOnboardingPageAction"
import { LOOKSMAXXING_CUSTOM_PURCHASE_FUNNEL_SLUGS } from "@helpers/looksmaxxingCustomPurchaseFunnel"
import looksmaxxingOnboardingLoader from "@loaders/looksmaxxingOnboardingLoader"
import { Navigate, Outlet } from "react-router-dom"
import AgePage from "../AgePage"
import CompanyPage from "../CompanyPage"
import ComplimentPage from "../ComplimentPage"
import ConfidenceBoostPage from "../ConfidenceBoostPage"
import FirstImpressionPage from "../FirstImpressionPage"
import GenderPage from "../GenderPage"
import HairstyleFrequencyPage from "../HairstyleFrequencyPage"
import PersonalityPage from "../PersonalityPage"
import PhotoUsagePage from "../PhotoUsagePage"
import SharePhotoPage from "../SharePhotoPage"
import SubscriptionCountPage from "../SubscriptionCountPage"
import TryFirstSubPage from "../TryFirstSubPage"
import LooksmaxxingAlmostTherePage from "./LooksmaxxingAlmostTherePage"
import LooksmaxxingBoldLooksPage from "./LooksmaxxingBoldLooksPage"
import LooksmaxxingDoingAmazingPage from "./LooksmaxxingDoingAmazingPage"
import LooksmaxxingExperimentingLookPage from "./LooksmaxxingExperimentingLookPage"
import LooksmaxxingFutureLookPage from "./LooksmaxxingFutureLookPage"
import LooksmaxxingReadyToTransformPage from "./LooksmaxxingReadyToTransformPage"
import LooksmaxxingStyleFeelingPage from "./LooksmaxxingStyleFeelingPage"
import LooksmaxxingStyleProfilePage from "./LooksmaxxingStyleProfilePage"
import LooksmaxxingUnleashLookPage from "./LooksmaxxingUnleashLookPage"

const action = navigateToNextLooksmaxxingOnboardingPageAction

const looksmaxxingOnboardingChildren = [
  {
    element: <Navigate to={`gender${window.location.search}`} replace />,
    index: true,
  },
  { action, element: <GenderPage />, path: "gender" },
  { action, element: <AgePage />, path: "age" },
  { action, element: <CompanyPage />, path: "company" },
  {
    action,
    element: <LooksmaxxingUnleashLookPage />,
    path: "unleashLook",
  },
  { action, element: <FirstImpressionPage />, path: "firstImpression" },
  { action, element: <TryFirstSubPage />, path: "tryFirstSub" },
  {
    action,
    element: <LooksmaxxingStyleFeelingPage />,
    path: "styleFeeling",
  },
  {
    action,
    element: <HairstyleFrequencyPage />,
    path: "hairstyleFrequency",
  },
  { action, element: <LooksmaxxingBoldLooksPage />, path: "boldLooks" },
  { action, element: <SharePhotoPage />, path: "sharePhoto" },
  {
    action,
    element: <LooksmaxxingExperimentingLookPage />,
    path: "experimentingLook",
  },
  {
    action,
    element: <LooksmaxxingDoingAmazingPage />,
    path: "doingAmazing",
  },
  { action, element: <ConfidenceBoostPage />, path: "confidenceBoost" },
  { action, element: <LooksmaxxingFutureLookPage />, path: "futureLook" },
  { action, element: <PersonalityPage />, path: "personality" },
  { action, element: <ComplimentPage />, path: "compliment" },
  {
    action,
    element: <LooksmaxxingStyleProfilePage />,
    path: "styleProfile",
  },
  {
    action,
    element: <LooksmaxxingReadyToTransformPage />,
    path: "readyToTransform",
  },
  { action, element: <PhotoUsagePage />, path: "photoUsage" },
  {
    action,
    element: <SubscriptionCountPage />,
    path: "subscriptionCount",
  },
  {
    action,
    element: <LooksmaxxingAlmostTherePage />,
    path: "almostThere",
  },
]

function looksmaxxingRouteTree(basePath: string) {
  return {
    path: basePath,
    element: <Outlet />,
    loader: looksmaxxingOnboardingLoader,
    children: looksmaxxingOnboardingChildren,
  }
}

const onboardingLooksmaxxingRoutes = [
  looksmaxxingRouteTree("/onboarding/looksmaxxing"),
  ...LOOKSMAXXING_CUSTOM_PURCHASE_FUNNEL_SLUGS.map((slug) =>
    looksmaxxingRouteTree(`/onboarding/looksmaxxing-${slug}`),
  ),
]

export default onboardingLooksmaxxingRoutes
